// types
import { ReportColumnDto } from 'src/api';
// constants
import { singleSelectAggregationModels } from '../constants/aggregation-model/single-select';

export function MembershipCategoryNameColumn(index: number) {
  const column = {
    field: 'membershipCategoryName',
    headerName: 'Membership category name',
    description: 'Membership category name column',
    type: 'singleSelect',
    valueOptions: ['Contingent', 'Campaign', 'Personal training', 'Drop in', 'Punch card'],
    index,
    width: 200,
    groupable: true,
    availableAggregationFunctions: singleSelectAggregationModels,
    headerAlign: 'center',
    align: 'center',
  } as ReportColumnDto<any, any, any>;
  return column;
}
